import Tab from './src/tab';
export default Tab;
